<template lang="pug">
    v-card
        //loading-dialog(:loading="loadingData")
        //crud-data-table.px-5.mt-5(
            v-if="!loadingData"
            :service="serviceTable" 
            :headers="headerTable" 
            :deleteButton="()=>{true}" 
            noAutoWidth 
            @show="submitShow($event)" 
            noSearchBox
            :filters="[]"
            )
        model-data-table(
            loading-text="Cargando documentos morosos..."
            no-data-text="Sin documentos morosos."
            no-search
            no-remove
            ref="table"
            v-bind="tableProps"
            @detail="submitShow"
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action( 
                    color='dark'
                    tooltip='PDF'
                    @click='submitPdf(props)' 
                )
                    v-icon picture_as_pdf
        detail-dialog(ref="invoiceDetailDialog" :invoiceId="invoiceId" readOnly)
</template>

<script>
//-
import { RBtnAction, ModelDataTable } from '@/components/reusable_components/next'
import SlSaleInvoiceMdl from '@/models/Sale/SlSaleInvoice.js'
import TableHeaders from '@/views/customer/tables/customerDefaulterInvoice/Headers.js'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
//-
export default {
    name: 'customer-defaulter-invoice-list',
    props: {},
    data: function() {
        return {
            headerTable: TableHeaders,
            customerId: null,
            invoiceId: null,
        }
    },
    computed: {
        tableProps() {
            return {
                service: SlSaleInvoiceMdl,
                paramFilter: {
                    sl_customer_id: this.customerId,
                    defaulter: 1,
                },
                headers: this.headerTable,
                filters: [
                    {
                        name: 'number',
                        type: 'text-field',
                        props: {
                            label: 'Folio',
                        },
                        flex: {
                            sm6: true,
                            lg5: true,
                        },
                    },
                ],
            }
        },
    },
    methods: {
        /**
         */
        setCustomerId() {
            this.customerId = this.$route.params.id
        },

        /**
         * @description
         * Print sale invoice PDF
         *
         * @param      {object}  event   The event
         * @return     {object}  blob file
         */
        submitPdf(event) {
            return event.item.toPdf()
        },

        /**
         */
        submitShow(event) {
            this.invoiceId = event.item.id
            this.$refs.invoiceDetailDialog.open = true
        },
    },
    watch: {},
    components: {
        RBtnAction,
        'model-data-table': ModelDataTable,
        'detail-dialog': DetailDialog,
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setCustomerId()
    },
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
